<template>
  <div style="
          float: left;
          position: absolute;
          z-index: 999;
          height:100%"
       class="img"
  >
    <img v-show="this.index == 1" style="width: 100%;" src="../assets/image/riskController1.png"/>
    <img v-show="this.index == 2" style="width: 100%;" src="../assets/image/riskController2.png"/>
    <img v-show="this.index == 3" style="width: 100%;" src="../assets/image/riskController3.png"/>
    <img v-show="this.index == 4" style="width: 100%;" src="../assets/image/riskController4.png"/>
    <img style="position: absolute;height: 100%;z-index: -1;top: 0;bottom: 0;" src="../assets/image/riskControllerBG.png"/>

<!--    <div id="floating-button-container" class="btn" >-->
      <van-button :disabled="this.index <= 1" style="margin-right: 5vw;" type="info" @click="last()">
        <span>上一项</span>
      </van-button>
      <van-button :disabled="this.index >= 4" style="margin-left: 5vw;" type="info" @click="next()">
        <span>下一项</span>
      </van-button>
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data(){
    return{
      index: 1,
    }
  },
  created(){
      this.axios.put("/wx/rc/count?index="+1)
  },
  methods:{
    last(){
      this.index = this.index-1;
      this.axios.put("/wx/rc/count?index="+this.index)
    },
    next(){
      this.index = this.index+1;
      this.axios.put("/wx/rc/count?index="+this.index)
    }
  }
}
</script>

<style scoped>
</style>